import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../../components/header/header";
import Hero from "./hero";
import SelectExam from "./exam";
import ExamPrep from "./exam-prep";
import StudyAnywhere from "./study-anywhere";
import HighExam from "./high-exam";
import TrackPerformance from "./track-performance";
import StudyExperience from "./study-experience";
import Subscriptions from "./subscriptions";
import FAQ from "./faq";
import Banner from "./banner";
import Footer from "../../components/footer/footer";
import { trackEvent } from "../../analytics/facebookPixel";

const Testimonials = React.lazy(() => import("./testimonials"));

const Home = () => {
  useEffect(() => {
    trackEvent("Visit Home Page");
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      easing: "ease-in-out",
      mirror: false,
      offset: 120,
      anchorPlacement: "top-center",
      disable: false
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });

    return () => {
      window.removeEventListener("scroll", () => {
        AOS.refresh();
      });
    };
  }, []);

  return (
    <HomeContainer>
      <Helmet>
        <title>
          GetThru — Medical Exam Question Banks for GSSE, BPS &amp; RACGP
        </title>
        <meta
          name="description"
          content="High-quality question banks for surgical and GP trainees in Australia and New Zealand. Study smarter for the GSSE, BPS and RACGP AKT exams. Start free today."
        />
        <link rel="canonical" href="https://get-thru.co.nz/" />
        {/* Preload the hero background image — it is the LCP element */}
        <link
          rel="preload"
          href="/assets/home/home-hero-bg.webp"
          as="image"
          {...({ fetchpriority: "high" } as any)}
        />
        {/* Preconnect to third-party origins used by GTM and Facebook Pixel */}
        <link
          rel="preconnect"
          href="https://www.googletagmanager.com"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://connect.facebook.net"
          crossOrigin="anonymous"
        />
        <meta
          property="og:title"
          content="GetThru — Medical Exam Question Banks for GSSE, BPS &amp; RACGP"
        />
        <meta
          property="og:description"
          content="High-quality question banks for surgical and GP trainees in Australia and New Zealand. Study smarter for the GSSE, BPS and RACGP AKT exams."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://get-thru.co.nz/" />
        <meta
          property="og:image"
          content="https://get-thru.co.nz/assets/home/logo.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="GetThru — Medical Exam Question Banks"
        />
        <meta
          name="twitter:description"
          content="Study smarter for the GSSE, BPS and RACGP AKT exams."
        />
        <script type="application/ld+json">{`
          [
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "GetThru",
              "url": "https://get-thru.co.nz",
              "logo": "https://get-thru.co.nz/assets/home/logo.png",
              "sameAs": [
                "https://www.facebook.com/profile.php?id=61551502415795"
              ],
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+64-777-729-830",
                "contactType": "customer support"
              }
            },
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "GetThru",
              "url": "https://get-thru.co.nz",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://get-thru.co.nz/blog?q={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }
          ]
        `}</script>
      </Helmet>
      <Header />
      <main>
        <HeroWrapper>
          <Hero />
        </HeroWrapper>
        <MadeBy
          src="/assets/home/a.webp"
          alt="Medical students studying"
          width={214}
          height={221}
          data-aos="zoom-in"
          data-aos-duration="1000"
        />
        <HomeWrapper>
          <SelectExam />
          <ExamPrep />
          <StudyAnywhere />
          <TrackPerformance />
          <HighExam />
          <StudyExperience />
          <React.Suspense fallback={null}>
            <Testimonials />
          </React.Suspense>
        </HomeWrapper>
        <Subscriptions />
        <HomeWrapper>
          <FAQ />
          <Banner />
        </HomeWrapper>
      </main>
      <Footer data-aos="fade-up" data-aos-duration="800" />
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const HomeWrapper = styled.div`
  background-color: #f9fbff;
  padding-bottom: 80px;
`;

const HeroWrapper = styled.div`
  position: relative;
  overflow: hidden;
  // background-color: #f9fbff;
`;

const MadeBy = styled.img`
  width: 145px !important;
  height: 152px !important;
  position: absolute;
  right: -30px;
  top: 630px;

  @media (min-width: 768px) {
    width: 184px !important;
    height: 194px !important;
    right: 270px;
    top: 530px;
    margin-bottom: 2.5rem;
  }
`;
export default Home;
